"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayStatusToJSON = exports.GiveawayStatusFromJSONTyped = exports.GiveawayStatusFromJSON = exports.GiveawayStatus = void 0;
/**
 * Giveaway status, used for filtering, indicates the current lifecycle status of the Giveaway
 * @export
 */
exports.GiveawayStatus = {
    Published: 'PUBLISHED',
    Active: 'ACTIVE',
    Resolved: 'RESOLVED'
};
function GiveawayStatusFromJSON(json) {
    return GiveawayStatusFromJSONTyped(json, false);
}
exports.GiveawayStatusFromJSON = GiveawayStatusFromJSON;
function GiveawayStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GiveawayStatusFromJSONTyped = GiveawayStatusFromJSONTyped;
function GiveawayStatusToJSON(value) {
    return value;
}
exports.GiveawayStatusToJSON = GiveawayStatusToJSON;
